import { faCheck } from '@awesome.me/kit-f3dc60f0d0/icons/classic/regular';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Trans } from '@lingui/react/macro';

import {
  getRecommendedProcedures,
  useGetRecommendationName,
} from '@/modules/patientList/patientStrip/patientStripOdontogram/utils';
import { usePreferences } from '@/react-query/usePreferences';
import type { TVisitSummary } from '@/react-query/useVisitSummaries';

interface Props {
  visitSummaryTooth?: TVisitSummary['teeth'][number];
  visitSummary?: TVisitSummary;
}

export const VisitSidebarRecommendation = ({
  visitSummaryTooth,
  visitSummary,
}: Props) => {
  const { data: preferences } = usePreferences();
  const recommendedProcedures = getRecommendedProcedures(
    visitSummaryTooth,
    preferences,
    undefined,
    visitSummary?.isPerioPatient,
  );
  const { getRecommendationName } = useGetRecommendationName();

  if (!visitSummaryTooth || !recommendedProcedures.length) return null;

  return (
    <div>
      <p className="vai-font-inter vai-text-xs vai-text-zinc-300 vai-uppercase vai-mb-2">
        <Trans>Recommendation</Trans>
      </p>
      <p className="vai-font-inter vai-text-sm vai-text-white">
        <FontAwesomeIcon className="vai-mr-1" icon={faCheck} />
        {recommendedProcedures
          .map(({ name }) => getRecommendationName(name))
          .join(' & ')}
      </p>
    </div>
  );
};
